import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ViewPackageDetailsService } from '../view-package-details/view-package-details.service';
import { ViewPackerMoverRequestService } from './view-packer-mover-request.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-view-packer-mover-request',
  templateUrl: './view-packer-mover-request.component.html',
  styleUrls: ['./view-packer-mover-request.component.sass']
})
export class ViewPackerMoverRequestComponent implements OnInit {
  packerMoverId:any;
  packerMoverList:any;
  selectedValue_furniture = "SOFA";
  selectedValue_appliances = "AC_COLLER_FAN";
  selectedValue_cartons = "CARTONS";


  appliances:any;
  furniture:any;
  cartons:any
  
  constructor(public activatedRoute: ActivatedRoute,
    private spinner : NgxSpinnerService,
    private toastr:ToastrService,
    private router: Router,
    private viewPMrequestService: ViewPackerMoverRequestService) { }

  ngOnInit(): void {
    this.packerMoverId=this.activatedRoute.snapshot.queryParams.id;
    // console.log(this.packerMoverId)
    this.getPackerMoverRequestById()
  }

  jsonData:any
  // getPackerMoverRequestById(){
  //     let data = {
  //       "id" : this.packerMoverId
  //     }
  //     this.spinner.show()
  //     this.viewPMrequestService.getPackerMoverById(data).subscribe((result:any)=>{
  //       if(result.statusCode == 200){
  //         console.log("packers&Movers order", result)
  //         this.spinner.hide()
  //         this.packerMoverList = result.data;
  //         this.furniture=JSON.parse(result.data.furniture)
  //         this.cartons=JSON.parse(result.data.cartons)
  //         this.appliances=JSON.parse(result.data.appliances)
  //         // console.log("cartons", this.cartons)
  //         // console.log("furniture",this.furniture)
  //         // console.log("appliances", this.appliances)
  //         // console.log(this.packerMoverList)
  //         this.jsonData={
  //           appliances:this.appliances,
  //           cartons:this.cartons
  //         }
  //       }else{
  //         this.spinner.hide()
  //         this.toastr.error(result.message)
  //       }
  //     })

  // }

  getPackerMoverRequestById() {

  let data = {
    id: this.packerMoverId
  };

  this.spinner.show();

  this.viewPMrequestService.getPackerMoverById(data).subscribe((result: any) => {

    if (result.statusCode == 200) {

      console.log("packers&Movers order", result);

      this.spinner.hide();

      this.packerMoverList = result.data;

      this.furniture = JSON.parse(result.data.furniture);
      this.cartons = JSON.parse(result.data.cartons);
      this.appliances = JSON.parse(result.data.appliances);

      // Calculate distance
      const distance = this.calculateDistance(
        Number(result.data.fromLatitude),
        Number(result.data.fromLongitude),
        Number(result.data.toLatitude),
        Number(result.data.toLongitude)
      );

      // console.log("Distance:", distance, "KM");

      // Store rounded distance
      this.packerMoverList.distance = Number(distance.toFixed(2));

      this.jsonData = {
        appliances: this.appliances,
        cartons: this.cartons
      };

    } else {

      this.spinner.hide();
      this.toastr.error(result.message);

    }
  });
}
    calculateDistance(
    fromLat: number,
    fromLng: number,
    toLat: number,
    toLng: number
  ): number {
    const R = 6371; // Earth's radius in kilometers

    const dLat = this.toRadians(toLat - fromLat);
    const dLng = this.toRadians(toLng - fromLng);

    const lat1 = this.toRadians(fromLat);
    const lat2 = this.toRadians(toLat);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }

toRadians(degrees: number): number {
  return degrees * (Math.PI / 180);
}
  selectFurniture(value:any){
    this.selectedValue_furniture = value
  }

  selectAppliances(value:any){
    this.selectedValue_appliances = value
  }

  selectCartons(value:any){
    this.selectedValue_cartons = value
  }

  exportToExcel() {
    const exportData: any[] = [];
  
    // Function to add subItems to exportData
    const addSubItemsToExport = (category: string, subItems: any) => {
      if (subItems) {
        let firstItem = true;
        for (const key of Object.keys(subItems)) {
          subItems[key].forEach((item: any) => {
            // Only include the item if qty is greater than 0
            if (item.qty > 0) {
              exportData.push({ 
                Category: firstItem ? category : '',  // Assign category only once
                Item: `${key}: ${item.name}`, 
                Details: item.qty 
              });
              firstItem = false;
            }
          });
        }
      } else {
        exportData.push({ Category: category, Item: 'No items', Details: 0 });
      }
    };
  
    function normalizeToNumber(value: any): number {
      const num = typeof value === 'string' ? Number(value) : value;
      return isNaN(num) ? 0 : num; // Return 0 if the value cannot be converted
    }
    // Add empty row between sections
    exportData.push({});
    // Add Package Info fields
    exportData.push({ Category: 'Package Info', Item: 'Package ID', Details: this.packerMoverList?.packageID });
    exportData.push({ Category: '', Item: 'Approximate Distance', Details: `${this.packerMoverList?.distance} KM` });
    exportData.push({ Category: '', Item: 'Sender Name', Details: this.packerMoverList?.senderName });
    exportData.push({ Category: '', Item: 'Sender Mobile', Details: this.packerMoverList?.senderMobile });
    exportData.push({ Category: '', Item: 'Shifting Date', Details: this.packerMoverList?.shiftingDate });
    exportData.push({ Category: '', Item: 'Pick up Address', Details: this.packerMoverList?.fromAddress });
    exportData.push({ Category: '', Item: 'Deliver Address', Details: this.packerMoverList?.toAddress });
    exportData.push({ Category: '', Item: 'Pick up Address Floor No.', Details: this.packerMoverList?.fromAddressFloorNo });
    exportData.push({ Category: '', Item: 'Deliver Address Floor No.', Details: this.packerMoverList?.toAddressFloorNo });
    exportData.push({ Category: '', Item: 'Pick Up Parking Distance', Details: this.packerMoverList?.fromAddressPackageDistance });
    exportData.push({ Category: '', Item: 'Drop Parking Distance', Details: this.packerMoverList?.toAddressPackageDistance });
    exportData.push({ Category: '', Item: 'Pick Up Time', Details: this.packerMoverList?.pickupTime });
    exportData.push({ Category: '', Item: 'Pick Up Service Lift', Details: this.packerMoverList?.fromAddressServiceLeft ? 'Available' : 'Not Available' });
    exportData.push({ Category: '', Item: 'Drop Service Lift', Details: this.packerMoverList?.toAdressServiceLeft ? 'Available' : 'Not Available' });
    exportData.push({ Category: '', Item: 'Total Items', Details: this.packerMoverList?.totalItemCount });
  
    // Add empty row between sections
    exportData.push({});
  
    // Add Bill Details fields
    exportData.push({ Category: 'Bill Details', Item: 'Payment Method', Details: this.packerMoverList?.paymentDetails?.paymentMethod });
    const paymentStatus = normalizeToNumber(this.packerMoverList?.paymentDetails?.status);
    exportData.push({ Category: '', Item: 'Payment Status', Details: paymentStatus === 1 ? 'Done' : 'Pending' });
    exportData.push({ Category: '', Item: 'Total Booking Amount', Details: this.packerMoverList?.paymentDetails?.totalAmount });
  
    // Add empty row between sections
    exportData.push({});

    // Export furniture
    addSubItemsToExport('Furniture', this.furniture?.subItems);

    // Add empty row between sections
    exportData.push({})

    // Export appliances
    addSubItemsToExport('Appliance', this.appliances?.subItems);
  
    // Add empty row between sections
    exportData.push({});
  
    // Export cartons
    addSubItemsToExport('Cartons', this.cartons?.subItems);
    
    exportData.push({});
    
    exportData.push({ Item: 'Total Items', Details: this.packerMoverList?.totalItemCount });
    // Create a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
  
    // Create a workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Items');
  
    // Export the workbook with packageID
    const packageId = (this.packerMoverList?.packageID || 'UnknownPackageID').toUpperCase(); 
    XLSX.writeFile(wb, `PM_Order_${packageId}.xlsx`);
  }
  
  back(){
    this.router.navigateByUrl('dashboard/packerMoverRequest')
  }
}
